import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core'
import { ArticleList, ArticleListItem } from '../article-list.interface'
import { AdComponentInputs } from '../../../shared/ads/ad/ad-component.interface'
import {
  AD_ADHESION_SIZE,
  AD_LEADERBOARD_LARGE_FLEX_SIZE,
  AD_LEADERBOARD_SMALL_SIZE,
  AD_RECTANGLE_LARGE_SIZE,
  AD_SKIN_SIZE
} from '../../../shared/ads/ads.utility'
import { AdConfig } from '../../../shared/ads/advertising-service/ad-config'
import { environment } from '../../../../environments/environment'
import { CardModel } from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import { convertArticleToCardModel } from '../../articles.utility'

@Component({
  selector: 'flo-article-list-view',
  templateUrl: './article-list-view.component.html',
  styleUrls: ['./article-list-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleListViewComponent {
  private articles: ArticleList = []

  public readonly loadMoreButtonText = 'See More'

  @Input()
  public set articleList(articles: ArticleList | null | undefined) {
    if (articles != null) {
      this.articles = articles
    }
  }

  /**
   * Emits when the next set of articles should be displayed (button clicked).
   */
  @Output() public readonly showMoreArticles = new EventEmitter<void>()

  public get allArticles(): ArticleList {
    return this.articles
  }

  public get firstTwoArticles(): ArticleList {
    return this.articles.slice(0, 2)
  }

  public get remainingArticles(): ReadonlyArray<CardModel> {
    return this.articles.slice(2).map(article => {
      // @ts-expect-error
      return convertArticleToCardModel(article)
    })
  }

  public trackByAnalyticsId: TrackByFunction<ArticleListItem> = (_, item) => item.analytics.node_id

  /* Ads Stuff */
  public AdComponent = import('../../../shared/ads/ad/ad.component').then(m => m.AdComponent)

  public adSkin: AdComponentInputs = {
    config: {
      adConfig: AdConfig('news/atf', AD_SKIN_SIZE, 'news-ad-skin'),
      additionalOpts: {
        deferClick: environment.advertising.preventClickTimeout
      }
    }
  }

  public leaderboardLarge: AdComponentInputs = {
    config: {
      adConfig: AdConfig('news/728x90_flex', AD_LEADERBOARD_LARGE_FLEX_SIZE, 'leaderboard-large'),
      additionalOpts: {
        deferClick: environment.advertising.preventClickTimeout
      }
    }
  }

  public leaderboardSmall: AdComponentInputs = {
    config: {
      adConfig: AdConfig('news/728x90_flex', AD_LEADERBOARD_SMALL_SIZE, 'leaderboard-small'),
      additionalOpts: {
        deferClick: environment.advertising.preventClickTimeout
      }
    }
  }

  public rightRailFlex: AdComponentInputs = {
    config: {
      adConfig: AdConfig('news/300x250_1', AD_RECTANGLE_LARGE_SIZE, 'right-rail-flex')
    }
  }

  public adhesion: AdComponentInputs = {
    config: {
      adConfig: AdConfig('news/adhesion', AD_ADHESION_SIZE, 'mobile-adhesion')
    }
  }

  // Track by to reduce DOM repainting as new options are dynamically loaded
  readonly trackById = trackById
}
